import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import {
	DEFAULT_LOAD_MORE,
	DEFAULT_PAGE_NUMBER,
} from '../../../../../constants';
import { clientBankIdentityRoute } from '../../route';

import { getPrivateCompaniesPageFilterFormSchema } from './components/PrivateCompaniesPageFilter/helpers/getPrivateCompaniesPageFilterFormSchema';

const privateCompaniesPageFilterFormSchema =
	getPrivateCompaniesPageFilterFormSchema();

export const privateCompaniesPageValidateSearchSchema = z.object({
	openedActivityUuid: z.string().optional(),
	pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
	loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
	filter: privateCompaniesPageFilterFormSchema.catch({}),
});

export const privateCompaniesRoute = createRoute({
	path: '/private-companies',
	getParentRoute: () => clientBankIdentityRoute,
	component: lazyRouteComponent(
		() => import('./PrivateCompaniesPage'),
		'PrivateCompaniesPage',
	),
	validateSearch: privateCompaniesPageValidateSearchSchema,
});
